import { atom } from 'jotai';

/**
 * Session-only set of deal ids for which the user has already triggered the
 * Shopify variant recovery ("Récupérer les déclinaisons Shopify") from the
 * anomalies sidebar.
 *
 * This lives purely in the user's session (never persisted to the backend):
 * it only drives the client-side UX. Once the recovery has been launched for a
 * deal, the duplicate-variant section additionally proposes extracting the
 * variant options from the product images for the Shopify duplicates the live
 * recovery could not differentiate — an image-based fallback the user can run
 * without leaving the sidebar.
 */
export const shopifyVariantRecoveryAttemptedDealIdsAtom = atom<Set<string>>(
  new Set<string>()
);
